
// Cache settings management
import { useState, useEffect } from "react";

// Default setting is false (cache disabled)
const CACHE_ENABLED_KEY = "chat_cache_enabled";

export const getIsCacheEnabled = (): boolean => {
  // Check localStorage if available
  if (typeof window !== "undefined" && window.localStorage) {
    const savedSetting = localStorage.getItem(CACHE_ENABLED_KEY);
    return savedSetting !== "false"; // Default to true (cache enabled)
  }
  // Default to true (cache enabled)
  return true;
};

export const setIsCacheEnabled = (enabled: boolean): void => {
  if (typeof window !== "undefined" && window.localStorage) {
    localStorage.setItem(CACHE_ENABLED_KEY, enabled.toString());
  }
};

export const useIsCacheEnabled = () => {
  const [isCacheEnabled, setIsCacheEnabled] = useState<boolean>(() => getIsCacheEnabled());
  
  useEffect(() => {
    setIsCacheEnabled(getIsCacheEnabled());
  }, []);
  
  const toggleCacheEnabled = () => {
    const newValue = !isCacheEnabled;
    setIsCacheEnabled(newValue);
    setIsCacheEnabled(newValue);
  };
  
  return { isCacheEnabled, toggleCacheEnabled };
};
